module.exports = __webpack_public_path__ + "img/vegetable-green-onions-190x100.ee2df109.jpg";